export const TELEGRAM_REDIRECT_URL = 'https://t.me/+6knXjnBRSRY2N2I6'
